import { Camera, Layers, Sparkles, TrendingUp, Heart, ShoppingBag } from 'lucide-react';

export const FEED_KINDS = [
  { kind: 'main', label: 'Main', path: '/feed', accent: 'var(--feed-main)', icon: Layers,
    blurb: 'Chronological hashtag feed. Real time. Unfiltered.' },
  { kind: 'creator', label: 'Creator', path: '/feed/creator', accent: 'var(--feed-creator)', icon: Sparkles,
    blurb: 'For creators: featured posts, blasts, enhanced tools.' },
  { kind: 'investor', label: 'Investor', path: '/feed/investor', accent: 'var(--feed-investor)', icon: TrendingUp,
    blurb: 'Accredited investors. Closed communities. Community funds.' },
  { kind: 'crowdfunder', label: 'Crowdfunder', path: '/feed/crowdfunder', accent: 'var(--feed-crowdfunder)', icon: Camera,
    blurb: 'Back projects. Boost to your network. Fund directly.' },
  { kind: 'dating', label: 'Dating', path: '/feed/dating', accent: 'var(--feed-dating)', icon: Heart,
    blurb: 'Hashtag-overlap matching. Activities and achievements.' },
  { kind: 'marketplace', label: 'Marketplace', path: '/feed/marketplace', accent: 'var(--feed-marketplace)', icon: ShoppingBag,
    blurb: 'Closer first. Hashtag-driven local commerce.' },
];

export function feedKindFromPath(pathname) {
  if (!pathname) return 'main';
  // Exact-match the more specific routes FIRST so '/feed/investor'
  // is not swallowed by the '/feed' prefix match for the Main feed.
  for (const f of FEED_KINDS) {
    if (f.kind === 'main') continue;
    if (pathname === f.path || pathname.startsWith(f.path + '/')) return f.kind;
  }
  if (pathname === '/feed' || pathname.startsWith('/feed?')) return 'main';
  if (pathname.startsWith('/feed/')) {
    // unknown sub-feed -> default to main
    return 'main';
  }
  return 'main';
}

export function getFeedConfig(kind) {
  return FEED_KINDS.find((f) => f.kind === kind) || FEED_KINDS[0];
}
